// extracted by mini-css-extract-plugin
export default {"container":"layout_container__5+urZ","section":"layout_section__kDRe8","main":"layout_main__HAbme","basket_icon":"layout_basket_icon__MuXCR"};